<div id="company-view" class="company-view">
    <div class="content">
        <div class="left">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Widget -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="30" fxFlex.gt-md="25" fxFlex.gt-lg="20">
                    <app-company-view-list [(loadTreeviewEmit)]="sendDataMaster"></app-company-view-list>
                </div>
                <!-- / Widget -->
                <!-- Widget -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="70" fxFlex.gt-md="75" fxFlex.gt-lg="80">
                    <app-company-view-detail (sendDataToTreeViewNode)="getData($event)"></app-company-view-detail>
                </div>
                <!-- / Widget -->
            </div>
        </div> 
    </div>
</div>